/**
 * Ids of the canvas's cards and of the ports on them, one port per row so a wire starts and ends at the
 * field it carries, and reading a port back to the argument, field or input it stands for.
 */

export const INPUTS_NODE = 'inputs';
export const RESULT_NODE = 'result';
export const ADD_NODE = 'add';

const STEP_NODE = 'step:';
const ARG_PORT = 'arg:';
const OUT_PORT = 'out:';
const INPUT_PORT = 'input:';

const withoutPrefix = (prefix: string, id: string | null | undefined): string | null => (id?.startsWith(prefix) ? id.slice(prefix.length) : null);

export const stepNodeId = (id: string): string => `${STEP_NODE}${id}`;
export const stepIdOfNode = (nodeId: string | null | undefined): string | null => withoutPrefix(STEP_NODE, nodeId);

export const argPort = (field: string): string => `${ARG_PORT}${field}`;
export const outPort = (path: string): string => `${OUT_PORT}${path}`;
export const inputPort = (name: string): string => `${INPUT_PORT}${name}`;
export const resultPort = (stepId: string): string => `result:${stepId}`;
/** The AI card's empty row: an argument dropped on it becomes a new input. */
export const NEW_INPUT_PORT = 'new-input';
export const RUN_FROM_PORT = 'next';
export const RUN_TO_PORT = 'prev';

export const argOfPort = (port: string | null | undefined): string | null => withoutPrefix(ARG_PORT, port);
export const pathOfPort = (port: string | null | undefined): string | null => withoutPrefix(OUT_PORT, port);
export const inputOfPort = (port: string | null | undefined): string | null => withoutPrefix(INPUT_PORT, port);
